import type { personalMenu } from '@/constants'
import { aboutUsMenu, businessMenu, digitalBankingMenu } from '@/constants'

import { isSamePath } from '@/utils/href'

// Map a pathname to its top-level tab id (mirrors the PillRadio ids in
// `tabItems`). Deriving the active pill straight from the URL — rather than
// reading store state that a post-mount effect sets — is what keeps the
// highlight correct in the static HTML (no flicker) and stops the pill from
// being reverted mid-navigation (the "click twice" bug).
export function getTabForPath(pathname: string) {
  if (pathname.includes('/business/')) return 1
  if (
    pathname.includes('/about') ||
    pathname.includes('/news') ||
    pathname.includes('/financial-report')
  )
    return 2
  if (
    pathname.includes('/digital') ||
    pathname.includes('/MY-alrajhi') ||
    pathname.includes('/virtualbanking')
  )
    return 3
  return 0
}

// Synchronously map a pathname to its top-level menu (mirrors getTabForPath).
// Used to seed state so the correct nav renders in the static HTML — not after
// a post-mount effect, which is what caused the navbar to flicker in.
export function getMenuForPath(pathname: string, fullPersonalMenu: typeof personalMenu) {
  switch (getTabForPath(pathname)) {
    case 1:
      return businessMenu
    case 2:
      return aboutUsMenu
    case 3:
      return digitalBankingMenu
    default:
      return fullPersonalMenu
  }
}

// The header is transparent (overlaying a hero) only on pages that drive the
// background from scroll position; everywhere else it starts solid/white.
export function getInitialScrolled(pathname: string) {
  return (
    !isSamePath(pathname, '/') &&
    !isSamePath(pathname, '/personal/cards/credit-cards') &&
    !isSamePath(pathname, '/MY-alrajhi')
  )
}
